




import { Component, Mixins } from 'vue-property-decorator';
import { NotFound } from '../../components/not-found';
import { MagicConfigMixin } from '@gig/magic-common';
@Component({
    components: {
        NotFound,
    },
})
export default class NotFoundPage extends Mixins(MagicConfigMixin) {

}
